// WIP image component

/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';

const Image = ({ data }) => {
  return <img className="image" alt={data.alt} src={data.src} srcSet={data.srcSet} sizes={data.sizes} />;
};

export default Image;
